// Loading placeholder for the natal chart wheel (homepage hero), shown
// while the demo/real chart data is being fetched. Replaces a generic
// spinning circle that gave no hint of what was about to render — this
// one echoes the wheel's own geometry (12 sectors, same viewBox) so the
// swap to the real <NatalChartWheel/> doesn't visually jump.
export default function NatalWheelSkeleton() {
  const size = 560, cx = size / 2, cy = size / 2, outerR = 210;
  return (
    <div className="relative w-full max-w-[560px] mx-auto animate-pulse" data-testid="natal-wheel-skeleton">
      <svg viewBox={`0 0 ${size} ${size}`} className="w-full h-auto" style={{ maxHeight: '560px' }}>
        <circle cx={cx} cy={cy} r={outerR} fill="none" stroke="#E2E8F0" strokeWidth="1.5" />
        {Array.from({ length: 12 }).map((_, i) => {
          const a = (i * 30 * Math.PI) / 180;
          return (
            <line
              key={i}
              x1={cx} y1={cy}
              x2={cx + Math.cos(a) * outerR} y2={cy + Math.sin(a) * outerR}
              stroke="#E2E8F0" strokeWidth="0.5"
            />
          );
        })}
        <circle cx={cx} cy={cy} r={2} fill="#CBD5E1" />
      </svg>
    </div>
  );
}
